/*
 *  ~ Copyright (c) by INFODATA-GROUP. All rights reserved.
 *  ~ No part of this publication may be reproduced, distributed,
 *  ~ or transmitted in any form or by any means, including photocopying, recording,
 *  ~ or other electronic or mechanical methods, without the prior written permission of the publisher,
 *  ~ except in the case of brief quotations embodied in critical
 *  ~ reviews and certain other noncommercial uses permitted by copyright law.
 *  ~ Author : BS
 *  ~ Date : 02/03/2022 11:38
 */

import { SerializedGenericCrudAuthorizationInterface } from '../../interface/serialized/serialized-generic-crud-authorization.interface';
import { IEntity } from '@infodata-group/inf-commons';

export class GenericCrudAuthorization implements IEntity {
  public create: boolean;
  public read: boolean;
  public update: boolean;
  public delete: boolean;

  public constructor(create = true, read = true, update = true, del = true) {
    this.create = create;
    this.read = !!read;
    this.update = !!update;
    this.delete = !!del;
  }

  public serialize(): SerializedGenericCrudAuthorizationInterface {
    return {
      create: this.create,
      read: this.read,
      update: this.update,
      delete: this.delete,
    };
  }

  lock: boolean;

  getId(): string {
    return '';
  }

  getLabel(): string {
    return '';
  }
}
